"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class CustomerClient extends authenticated_client_1.AuthenticatedClient {
    getCustomerParentById(customerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const customerByIdUrl = `/v1/customers/${customerId}/parent`;
            const response = yield this.httpGet(customerByIdUrl);
            return response.payload;
        });
    }
    getCustomer(customerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const customerByIdUrl = `/v1/customers/${customerId}`;
            const response = yield this.httpGet(customerByIdUrl);
            return response.payload;
        });
    }
    getEmployees(customerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const customers = `/v2/customers/${customerId}/users`;
            const response = yield this.httpGet(customers);
            return response.payload;
        });
    }
    getCustomersByProjectId(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const customerByProjectIdUrl = `/v2/customers/projects/${projectId}`;
            const response = yield this.httpGet(customerByProjectIdUrl);
            return response.payload;
        });
    }
}
exports.CustomerClient = CustomerClient;
//# sourceMappingURL=customer.client.js.map